import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/soyuz/client';
import { IconGeneric } from '@spotahome/ui-library';

import './Paginator.scss';

const getClassNames = (isButtonDisabled, role) => ({
  className: classNames('paginator--button', `paginator--button__${role}`, {
    'paginator--button__disabled': isButtonDisabled
  })
});

class Paginator extends PureComponent {
  static propTypes = {
    previousButtonDisabled: PropTypes.bool,
    nextButtonDisabled: PropTypes.bool,
    onPreviousButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func,
    previousPageUrl: PropTypes.string.isRequired,
    nextPageUrl: PropTypes.string.isRequired
  };

  static defaultProps = {
    previousButtonDisabled: false,
    nextButtonDisabled: false,
    onPreviousButtonClick: () => {},
    onNextButtonClick: () => {}
  };

  handlePreviousClick = e => {
    e && e.preventDefault();
    this.props.onPreviousButtonClick();
  };

  handleNextClick = e => {
    e && e.preventDefault();
    this.props.onNextButtonClick();
  };

  render() {
    const {
      previousButtonDisabled,
      nextButtonDisabled,
      previousPageUrl,
      nextPageUrl
    } = this.props;

    return (
      <div className="paginator">
        <button
          onClick={this.handlePreviousClick}
          {...getClassNames(previousButtonDisabled, 'prev')}
        >
          <IconGeneric name="angle-left" /> {trans('paginator.label.prev')}
          <a href={previousPageUrl} />
        </button>
        <button
          onClick={this.handleNextClick}
          {...getClassNames(nextButtonDisabled, 'next')}
        >
          {trans('paginator.label.next')} <IconGeneric name="angle-right" />
          <a href={nextPageUrl} />
        </button>
      </div>
    );
  }
}

export default Paginator;
